module.exports = __webpack_public_path__ + "img/ios-home-04.c84830b8.jpg";